import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LinkCodeComponent } from './link-code/link-code.component';


export const listcodeRoutes: Routes = [
  {
    path: 'list-code',
    component: LinkCodeComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(listcodeRoutes)],
  exports: [RouterModule]
})
export class ListCodeRoutingModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/list-code/list-code-routing.module.ts